import '../css/responsive-legend.css';
import { LegendItem } from '../LegendItems/LegendItem';
import type { VerticalLegendProps } from './VerticalLegend.types';

export const VerticalLegend = ({
  children = null,
  className,
  unit,
  handleClick,
  checkIfSelected,
  checkIfFiltered: _checkIfFiltered,
  selected,
  grouping_key,
  legend_items
}: VerticalLegendProps): React.JSX.Element | null => {
  if (!legend_items?.length) return null;

  return (
    <div
      className={['responsive-legend', 'responsive-legend--vertical', className].filter(Boolean).join(' ')}
    >
      <div data-area='items'>
        {legend_items.map((item) => {
          const is_selected = checkIfSelected?.(
            item,
            'legend',
            selected,
            { selected, grouping_key, unit  },
          );

          return (
            <LegendItem
              {...item}
              item={item}
              is_selected={is_selected}
              key={String(item.label)}
              handleClick={handleClick}
              checkIfSelected={checkIfSelected}
              checkIfFiltered={_checkIfFiltered}
              selected={selected}
              grouping_key={grouping_key}
              chart_unit={unit}
              unit={item.unit ?? unit}
            />
          );
        })}
        {children}
      </div>
    </div>
  );
};
